import { useState } from 'react'
import * as API from '../../utility/api'
import moment from 'moment'

const ACTIONS = {
  TICKETS_OVERPAID: 'tickets_overpaid',
  DEBT: 'debt'
}

const Tools = () => {

    const [action, setAction] = useState(ACTIONS.TICKETS_OVERPAID)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(null)

    const fetchData = e => {
        e.preventDefault()

        setLoading(true)

        API.GET(`admin/tools/${action}`, {})
            .then(({ data }) => {
            console.log(data)
            setData(data)
            setLoading(false)
            //setRaportData(data)
            })
            .catch(e => console.error(e))
    }

    return (
    <div>
        <form className="admin-panel--raports--form-container" onSubmit={fetchData}>
        <div className="admin-panel--raports--form">

            <h3>Toiminto</h3>
            <label htmlFor="debt">
            <input
                id="debt"
                className="raport-radio"
                type="radio"
                checked={action === ACTIONS.TICKETS_OVERPAID}
                onChange={() => setAction(ACTIONS.TICKETS_OVERPAID)}
            />
            <span style={{ marginLeft: '5px' }}>Liput, joissa on liikaa maksuja</span>
            </label>



            <button disabled={loading} type="submit">
            {loading ? 'Ladataan....' : 'Lataa'}
            </button>
        </div>
        </form>
        <ToolsResult data={data} />
    </div>
  )
}

const ToolsResult =  ({ data })  => {

  return toolsResultOverpaidTickets(data)
}

const toolsResultOverpaidTickets = (data) => {

    const renderTicket = (ticket) => {
        return (
            <tr key={ticket.order_product_id} style={{ borderBottom: '1px solid #888888' }}>
                <td>{ticket.original_code}</td>    
                <td>{ticket.event_name}</td>  
                <td><a href={'https://pipetti.tiketti.fi/tilaus/' + ticket.tiketti_order_id}  target="_blank" rel="noreferrer">{ticket.tiketti_order_code}</a></td>
                <td> {ticket.price/100} €</td>
                <td>{ticket.transaction_id}</td> 
                <td>{moment(new Date(ticket.paytrail_payed_at)).format('YYYY-MM-DD HH:mm:ss')}</td> 
                <td>{ticket.first_name} {ticket.last_name}<br/>{ticket.email}</td>
            </tr>
        )
    }

    return (
        <div>
            <h2>Liput, joissa on liikaa maksuja</h2>
            {
            data && data.tickets.length === 0 && <div>Ei löytynyt lippuja, joissa olisi liikaa maksuja.</div>
            }
            {
            // render tickets
            //data && data.tickets && renderTickets(data.tickets)
            // table header
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th>Lippukoodi</th>
                        <th>Tapahtuma</th>
                        <th>Pipetti Tilaus</th>
                        <th>Hinta (€)</th>
                        <th>Transaktio ID</th>
                        <th>Maksettu</th>
                        <th>Asiakas</th>
                    </tr>
                </thead>
                <tbody> 
                {data && data.tickets && data.tickets.map(ticket => renderTicket(ticket))}
                </tbody>
            </table>
            }
        </div>
    )
}


export default Tools